import { ReactNode, createContext, useContext } from 'react'

const HasEarlierWavesContext = createContext(false)

/** Whether this tracker wave has an earlier wave; false outside one. */
export const useHasEarlierWaves = () => useContext(HasEarlierWavesContext)

export const HasEarlierWavesProvider = ({
  value,
  children
}: {
  value: boolean
  children: ReactNode
}) => (
  <HasEarlierWavesContext.Provider value={value}>
    {children}
  </HasEarlierWavesContext.Provider>
)
